// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3tGL-","label":"Section_label__2WUyY","contentWrap":"Section_contentWrap__zRNzy","footer":"Section_footer__HDvv7","footerInner":"Section_footerInner__17Awf"};